import styled from 'styled-components';
import { useEffect, useRef } from 'react';
import { useQuestionContext } from '../../../context/chatbot/QuestionContextApi';
import { useHospitalContext } from '../../../context/chatbot/HospitalContextApi';
import LocalIcon from '../../../ui/LocalIcon';
import BadgeProfileDropdown from '../../Dropdown/BadgeProfileDropdown';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

const LogoContainer = styled.div`
  direction: ${({ theme }) => theme.direction};
  display: flex !important;
  justify-content: start !important;
  align-items: center !important;
  gap: 0.5rem !important;
`;

const Image = styled.img`
  height: 5rem;
  width: auto;
  object-fit: cover;
  padding: 0.25rem;
  margin: 0.25rem;
  border-radius: 10rem;
`;
const BrandName = styled.h1`
  font-weight: 450;
  padding: 1rem;
  font-size: 2rem;
  color: var(--exact-white);
`;

interface IProps {
  companyId: number;
}

const Logo: React.FC<IProps> = ({ companyId }) => {
  const user = useSelector((state: RootState) => state.thisUser);

  const hospital = useHospitalContext();
  const logo = hospital!.hospitalInitialInformation?.logo;
  const pageRef = useRef<HTMLDivElement | null>(null);

  const questionContext = useQuestionContext();

  if (!questionContext) {
    throw new Error('useQuestionContext must be used within a cntx.Provider');
  }

  if (!hospital) {
    throw new Error(
      'useHospitalContext must be used within a hospitalProvider'
    );
  }

  const {
    question: { content },
  } = questionContext;

  const scrollToTop = () => {
    const headerContainer = pageRef.current;
    if (headerContainer) {
      headerContainer.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    scrollToTop();
  }, [content]);

  return (
    <LogoContainer className="!md:w-[80%] !w-[95%] !mx-auto" ref={pageRef}>
      {logo && <Image src={logo} />}
      <BrandName>{hospital!.hospitalInitialInformation.name}</BrandName>
      <div
        style={{
          marginInlineStart: 'auto',
          display: 'flex',
          alignItems: 'center',
          gap: '3rem',
        }}
      >
        {user.isLoggedIn && (
          <BadgeProfileDropdown
            direction={'bottom'}
            user={user}
            companyId={companyId as number}
            isHidden={false}
          />
        )}

        <LocalIcon
          iconName="close-square.svg"
          color="no-color"
          type="lg"
          onClick={() => {
            hospital.onChangeChatStatus(false);
            window.history.back();
          }}
          isLink={true}
        />
      </div>
    </LogoContainer>
  );
};

export default Logo;
